export const I_TRADE_ACTION = {
  GET_TRADING_ACCOUNT: 'GET_TRADING_ACCOUNT',
  SWITCH_TRADING_ACCOUNT: 'SWITCH_TRADING_ACCOUNT',
  GET_MARKET: 'GET_MARKET',
  SET_CURRENT_TRADING_ACCOUNT: 'SET_CURRENT_TRADING_ACCOUNT',
  GET_TRADING_CONFIG_SETTING: 'GET_TRADING_CONFIG_SETTING',
  SET_CURRENT_MARKET: 'SET_CURRENT_MARKET',
  SET_TRADE_DATE_INFO: 'SET_TRADE_DATE_INFO',
  SET_GOOD_TILL_DATE: 'SET_GOOD_TILL_DATE',
  SET_ORDER_TYPE: 'SET_ORDER_TYPE',
  GET_CLIENT_CCY_LIST: 'GET_CLIENT_CCY_LIST',
  GET_INSTRUMENT_INFO: 'GET_INSTRUMENT_INFO',
  GET_POSITION_DATA: 'GET_POSITION_DATA',
  SET_MARKET_STOCK: 'SET_MARKET_STOCK',
  SET_NO_CHANGE_MARKET_STOCK:'SET_NO_CHANGE_MARKET_STOCK',
  SET_MDS_TOKEN: 'SET_MDS_TOKEN',
  GET_INSTRUMENT_HISTORICAL_DATA: 'GET_INSTRUMENT_HISTORICAL_DATA',
  SET_QUOTE_ACCOUNT: 'SET_QUOTE_ACCOUNT',
  STOP_QUTO_REFRESH: 'STOP_QUTO_REFRESH',
  GET_ACCOUNT_BANLANCE :'GET_ACCOUNT_BANLANCE',
  GET_AVAIABLE_QUANTITY : 'GET_AVAIABLE_QUANTITY',
  CLEAR_TRADING_ACCOUNT :'CLEAR_TRADING_ACCOUNT',
  GET_PASSWORD_RULE: 'GET_PASSWORD_RULE',
  SET_PLACE_ORDER_PARAMS: 'SET_PLACE_ORDER_PARAMS',
  SET_DEPOSIT_BANK_ACCOUNT:'SET_DEPOSIT_BANK_ACCOUNT',
  SET_WITHDRAWAL_BANK_ACCOUNT:'SET_WITHDRAWAL_BANK_ACCOUNT',
  SET_WITHDRAWAL_BANK_ACCOUNT2:'SET_WITHDRAWAL_BANK_ACCOUNT2',
  GET_QUOTE_DETAIL: "GET_QUOTE_DETAIL",
  SET_MDS_AGREEMENT: "SET_MDS_AGREEMENT",
	SET_MDS_STOCKS: "SET_MDS_STOCKS",
}